<template>
  <div>
    <b-modal ref="instant-tournament-history-ladder-modal"
       :title="$t('tournament_history.modal.ladder.title')"
       @ok="resetModal"
       @cancel="resetModal"
       @hidden="resetModal"
       ok-only
       size="xl"
    >
      <div
          v-for="(level, index) of tournamentLadder"
          :key="index"
          :style="{'backgroundColor': index % 2 === 0 ? '#e9eff4' : ''}"
          class="h6 w-100 p-4"
      >
        <div
            v-for="(room, roomIndex) in level"
            :key="roomIndex"
            class="text-primary"
        >
            <div v-if="roomIndex === 0 && room.isFinal" class="text-bold">
              {{ $t('tournament_history.modal.ladder.final_level') }}
            </div>
            <div v-if="roomIndex === 0 && !room.isFinal" class="text-bold">
              {{ $t('tournament_history.modal.ladder.level') }}: {{ room.level }}
            </div>
        </div>
        <div class="d-flex w-100 mt-4 mb-4" style="overflow-x: auto">
          <div
              v-for="(room, roomIndex) in level"
              :key="roomIndex"
              class="p-4"
              style="min-width: 25%;"
              :style="{'backgroundColor': roomIndex % 2 === 0 ? '#dee2e6' : ''}"
          >
            <div
                v-for="(player, playerIndex) in sortPlayersByPlace(room.players.slice())"
                :key="playerIndex"
                class="d-flex flex-column mt-3 mb-3 w-100"
            >
              <div class="d-flex align-items-center mb-1">
                <span class="text-bold">{{ player.place }}</span>: {{ player.nickName }}
                <div
                    v-if="!room.isFinal"
                    class="text-bold h6 m-0 ml-2"
                    :class="player.qualified ? 'text-success' : 'text-danger'"
                >
                  {{ player.qualified ? '+' : '-' }}
                </div>
              </div>
              <div v-if="(!player.qualified || room.isFinal) && awards[player.id]">{{ $t('tournament_history.modal.ladder.award') }}: <span class="text-bold">{{ awards[player.id].award }} {{ currency === 'FUN_COINS' ? $t('FUN_COINS') : $t('QUIZ_COINS') }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data() {
    return {
      tournamentLadder: [],
      awards: {}
    }
  },
  computed: {
    orderedUsers: function () {
      return _.orderBy(this.users, 'name')
    }
  },
  methods: {
    sortPlayersByPlace(arr) {
      return _.orderBy(arr, 'place')
    },
    resetModal() {
      this.tournamentLadder = [];
      this.awards = {};
    },
    showLadder(data) {
      this.currency = data.currency;

      data.awards.forEach(award => {
        this.awards[award.id] = award;
      })

      this.tournamentLadder = data.ladder.reduce((group, product) => {
        const { level } = product;
        group[level] = group[level] ?? [];
        group[level].push(product);
        return group;
      }, {});

      this.tournamentLadder = Object.values(this.tournamentLadder).reverse()

      this.$refs['instant-tournament-history-ladder-modal'].show();
    }
  }
}
</script>
